import { __extends } from "tslib";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Dashboards } from "../Dashboards";
import { ReportTable } from "../ReportTable";
import { ITab, TabsControl as Tabs } from "../Tabs";
import { ISelectedNode } from "../../models/node";
import { ITranslations } from "../../models/translations";
import { IAsyncState } from "../../state/action";
import { loadDataOptimized } from "../../state/actions";
import { IReportBuilderState } from "../../state/reducers";
import { IRgb } from "../../utils/Color";
import { Spinner } from "../Spinner";
var ReportTabs = (function (_super) {
    __extends(ReportTabs, _super);
    function ReportTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadOptimizedData = function () {
            var _a = _this.props, request = _a.request, dataOptimized = _a.dataOptimized, onLoadOptimizedData = _a.onLoadOptimizedData;
            if (request &&
                (!dataOptimized ||
                    (!dataOptimized.data &&
                        !dataOptimized.error &&
                        !dataOptimized.isFetching))) {
                onLoadOptimizedData(request);
            }
        };
        _this.renderTabs = function () {
            var _a = _this.props, defaultTab = _a.defaultTab, showDataTabs = _a.showDataTabs, loader = _a.loader;
            if (!showDataTabs) {
                return null;
            }
            return (React.createElement("div", { id: "rbReportTabsContainer" },
                React.createElement(Tabs, { id: "rb-report-tabs", defaultTab: defaultTab, tabsItems: _this.getTabsItems(), loader: loader })));
        };
        _this.getTabsItems = function () {
            var _a = _this.props, dataOptimized = _a.dataOptimized, showChart = _a.showChart, showDataTable = _a.showDataTable, t = _a.t;
            var loading = dataOptimized && dataOptimized.isFetching;
            var error = dataOptimized && dataOptimized.error;
            var tabsItems = [];
            if (showChart) {
                tabsItems.push({
                    title: t.chartTab,
                    loading: loading,
                    error: error,
                    content: _this.renderChartTab(),
                    visible: true,
                });
            }
            if (showDataTable) {
                tabsItems.push({
                    title: t.tableTab,
                    loading: loading,
                    error: error,
                    content: _this.renderTableTab(),
                    visible: true,
                });
            }
            return tabsItems;
        };
        _this.renderWithoutTabs = function () {
            var showDataTabs = _this.props.showDataTabs;
            if (showDataTabs) {
                return null;
            }
            return (React.createElement(Fragment, null,
                _this.renderChart(),
                _this.renderDataTable()));
        };
        _this.renderChartTab = function () {
            return React.createElement("div", { className: "rb-report-tab-content" }, _this.renderChart());
        };
        _this.renderChart = function () {
            var _a = _this.props, dataOptimized = _a.dataOptimized, selectedDimensions = _a.selectedDimensions, selectedMetrics = _a.selectedMetrics, showChart = _a.showChart, t = _a.t, chartColors = _a.chartColors;
            var data = dataOptimized && dataOptimized.data;
            if (!showChart) {
                return null;
            }
            return (React.createElement(Dashboards, { data: data, dimensions: selectedDimensions, metrics: selectedMetrics, t: t, chartColors: chartColors }));
        };
        _this.renderTableTab = function () {
            return (React.createElement("div", { className: "rb-report-tab-content" }, _this.renderDataTable()));
        };
        _this.renderDataTable = function () {
            var _a = _this.props, dataOptimized = _a.dataOptimized, showDataTable = _a.showDataTable, t = _a.t;
            var data = dataOptimized && dataOptimized.data;
            if (!showDataTable) {
                return null;
            }
            return React.createElement(ReportTable, { data: data, t: t });
        };
        return _this;
    }
    ReportTabs.prototype.componentDidMount = function () {
        this.loadOptimizedData();
    };
    ReportTabs.prototype.componentDidUpdate = function () {
        this.loadOptimizedData();
    };
    ReportTabs.prototype.render = function () {
        var _a = this.props, showChart = _a.showChart, showDataTable = _a.showDataTable;
        if (!showChart && !showDataTable) {
            return null;
        }
        return (React.createElement(Fragment, null,
            this.renderTabs(),
            this.renderWithoutTabs()));
    };
    ReportTabs.defaultProps = {
        showDataTabs: true,
        showChart: true,
        showDataTable: true,
        defaultTab: 0,
        loader: React.createElement(Spinner, null),
    };
    return ReportTabs;
}(React.PureComponent));
var connected = connect(function (state) {
    var dataOptimized = state.dataOptimized, selectedDimensions = state.selectedDimensions, selectedMetrics = state.selectedMetrics, request = state.request, translations = state.translations;
    return {
        selectedDimensions: selectedDimensions,
        selectedMetrics: selectedMetrics,
        dataOptimized: dataOptimized,
        request: request,
        t: translations,
    };
}, function (dispatch) {
    return {
        onLoadOptimizedData: function (request) {
            return dispatch(loadDataOptimized(request));
        },
    };
})(ReportTabs);
export { connected as ReportTabs };
